<template>
  <v-dialog v-model="dialog" activator="" fullscreen attach="">
    <template v-slot:activator="{ on, attrs }">
      <v-btn rounded color="teal" v-on="on" v-bind="attrs" block text dark>
        <v-icon left>mdi-draw-pen</v-icon> Assinar Pedido</v-btn
      >
    </template>
    <v-card>
      <v-toolbar color="primary" max-height="56" dark>
        <v-btn icon @click="dialog = false"
          ><v-icon>mdi-arrow-left</v-icon></v-btn
        >
        <v-toolbar-title>Assinatura do cliente</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="mt-4">
        <v-overlay v-if="bloquearAssinatura()" opacity=".8">
          <v-row>
            <v-col cols="12" class="text-center">
              <span class="title pa-2"
                >Utilize o modo paisagem para assinar seu pedido</span
              >
            </v-col>
            <v-col cols="12" class="text-center">
              <v-btn @click="dialog = false" color="info">OK</v-btn>
            </v-col>
          </v-row>
        </v-overlay>
        <v-row>
          <v-col cols="6">
            <v-btn
              rounded
              @click="limpar()"
              outlined
              block
              class="mb-3"
              height="30"
              color="error"
            >
              <v-icon left>mdi-close</v-icon> Limpar</v-btn
            >
          </v-col>
          <v-col cols="6">
            <v-btn
              rounded
              color="success"
              outlined
              @click="confirmarAssinatura()"
              block
              height="30"
            >
              <v-icon left>mdi-check</v-icon>Confirmar</v-btn
            >
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" class="text-center">
            <VPerfectSignature
              :stroke-options="strokeOptions"
              ref="signaturePad"
              id="signature"
              class="mt-1"
              height="400px"
              :width="widthAssinatura()"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import VPerfectSignature from "v-perfect-signature";
import { mapMutations, mapState } from "vuex";
export default {
  components: {
    VPerfectSignature,
  },
  data: () => ({
    dialog: false,
    strokeOptions: {
      size: 7.5,
      thinning: 0.5,
      smoothing: 0.5,
      streamline: 0.5,
    },
  }),
  computed: mapState("pedidos", ["novopedido"]),
  methods: {
    ...mapMutations("sistema", ["setErrorRequest", "setMsgError"]),
    limpar() {
      this.$refs.signaturePad.clear();
      this.novopedido.assinatura = "";
    },
    confirmarAssinatura() {
      if (this.$refs.signaturePad.isEmpty()) {
        this.setErrorRequest(true);
        this.setMsgError("Assinatura inválida");
      } else {
        this.novopedido.assinatura = this.$refs.signaturePad.toDataURL();
        this.dialog = false;
      }
    },
    widthAssinatura() {
      return `${screen.width * 1.6}px`;
    },
    bloquearAssinatura() {
      return screen.orientation.type.toLowerCase().startsWith("portrait");
    },
  },
};
</script>

<style>
#signature {
  background-color: rgba(128, 128, 128, 0.39);
}
</style>